import React from 'react';
import { s } from '../styles';
import { BulletCard } from '../atoms';
import { IconPerson, IconSqueeze, IconCheck } from '../icons';

// Screen 8 — Squeeze tips. Three multi-sentence tips at the full
// 18px / 1.7 reading rhythm (squeezeTipLine override).
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <h1 style={s.title} className="screen-enter-child">{t('fl_squeeze_tips_title')}</h1>
      <div style={s.bulletStack} className="screen-enter-child">
        <BulletCard icon={<IconPerson />} className="stagger-item" style={{ '--stagger-i': 0 }}>
          <div style={s.squeezeTipLine}>{t('fl_squeeze_tip_1')}</div>
        </BulletCard>
        <BulletCard icon={<IconSqueeze />} className="stagger-item" style={{ '--stagger-i': 1 }}>
          <div style={s.squeezeTipLine}>{t('fl_squeeze_tip_2')}</div>
        </BulletCard>
        <BulletCard icon={<IconCheck />} className="stagger-item" style={{ '--stagger-i': 2 }}>
          <div style={s.squeezeTipLine}>{t('fl_squeeze_tip_3')}</div>
        </BulletCard>
      </div>
    </div>
  );
}

export function Footer({ t, onNext }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onNext}>
      {t('fl_squeeze_tips_cta')}
    </button>
  );
}
